import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import { countries, Country } from '../providers/LanguageProvider';
import { selectLocale } from '../selectors';

export default function useCurrentCountry(): Country {
  const locale = useSelector(selectLocale);

  const country = useMemo(() => {
    // Extract language from locale. `es-US` -> `es`
    const res = locale && _.get(locale.match(/(\w+)-/), 2);

    // Ensure the language is supported
    if (!res || !_.includes(countries, res)) {
      return Country.US;
    }
    return res as Country;
  }, [locale]);

  return country;
}
